import React from 'react';

import {Card, CircularProgress, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import IconButton from "@mui/joy/IconButton";
import Typography from "@mui/joy/Typography";


class StickerPack extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stickers: null,
        }
    }

    async componentDidMount() {
        await this.retrieveStickers()
    }

    async retrieveStickers(){
        const url = `sticker/`;
        const api = new BaseApi();
        let params = {
            pack: this.props.pack.id,
            page_size: 10000,
        };
        let response = await api.get(
            url,
            params
        );
        this.setState({
            stickers: response.data.results
        })
    }

    render() {
        if (!this.state.stickers) {
            return (
                <CircularProgress/>
            )
        }
        return(
            <Stack
                spacing={2}
                sx={{
                    overflowY: 'scroll'
                }}
            >
                <Card
                    size={'sm'}
                    variant={'soft'}
                >
                    <Stack
                        direction={'row'}
                        useFlexGap
                        sx={{
                            flexWrap: 'wrap',
                        }}
                        alignItems={'center'}
                        spacing={1}
                    >
                        <IconButton
                            onClick={this.props.unsetCallBack}
                        >
                            {'<'}
                        </IconButton>
                        <Typography>
                            <strong>{this.props.pack.title}</strong>
                        </Typography>
                    </Stack>
                </Card>
                <Stack
                    direction={'row'}
                    spacing={1}
                    useFlexGap
                    sx={{
                        flexWrap: 'wrap',
                        overflowY: 'scroll'
                    }}
                >
                    {
                        this.state.stickers.map((s) => (
                            <img
                                style={{
                                    cursor: 'pointer'
                                }}
                                onClick={() => {
                                    this.props.addStickerCallback(s.id)
                                }}
                                src={`data:image/png;base64,${s.thumbnail}`}
                            />
                        ))
                    }
                </Stack>
            </Stack>
        )
    }
}

export default StickerPack
